<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Rezeptabschnitte</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-card v-for="(row, index) in postItem.content_container" v-bind:key="index" class="col-12" elevation="0">
                    <template>
                        <v-card-title>
                            <v-select :items="dynamicContentType"
                                      label="Art"
                                      :value="row.content_type"
                                      v-model="row.content_type"
                            ></v-select>
                        </v-card-title>
                        <v-card-text v-show="row.content_type != 0">
                            <v-text-field v-show="row.content_type == 4" label="Hinweistitel" v-model="row.content_element_title" ></v-text-field>

                            <v-text-field v-show="row.content_type == 3" label="Abschnittstitel" v-model="row.content_element_title" ></v-text-field>
                            <vue-editor v-show="row.content_type != 6" :editorToolbar="recipePartInformationToolbar" v-model="row.content_element_text" :id="'textEdit_'+index"></vue-editor>

                            <v-text-field v-show="row.content_type == 3" label="Zeit" v-model="row.step_attribute_zeit" ></v-text-field>
                            <v-slider
                                    v-show="row.content_type == 3"
                                    v-model="row.step_attribute_temperatur"
                                    prepend-icon="mdi-temperature-celsius"
                                    min="0"
                                    max="280"
                            >
                                <template v-slot:append>
                                    <v-text-field
                                            label="Temperatur"
                                            v-model="row.step_attribute_temperatur"
                                            class="mt-0 pt-0"
                                            single-line
                                            type="text"
                                            readonly
                                            style="width: 50px"
                                    ></v-text-field>
                                </template>
                            </v-slider>
                            <v-select @change="showHelpText" v-show="row.content_type == 3" label="Heizart" v-model="row.step_attribute_heizart" :items="stepAttributeHeizart"></v-select>

                            <v-text-field v-if="row.content_type == 6" label="YouTube ID" v-model="row.content_element_text" ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <a @click="removeElementFromParts(index,'recipe')" style="cursor: pointer"><v-icon>delete</v-icon></a>
                        </v-card-actions>
                    </template>
                </v-card>
                <v-alert
                        v-show="helptext != ''"
                        dense
                        border="left"
                        type="warning"
                >
                    {{helptext}}
                </v-alert>
                <v-btn @click="addRowToParts">Rezeptabschnitt hinzufügen</v-btn>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  export default {
    name: 'PostRecipePartsComponent',
    props:['postItem'],
    components:{
      VueEditor
    },
    beforeMount () {
      this.postItem.content_container.forEach(item => {
        if(item.content_type == 6){
          item.content_element_text = this.stripTags(item.content_element_text);
        }
      });
    },
    data: () => {
      return {
        helptext: '',
        dynamicContentType:[
          {text:'Tipp/Hinweis/Warnung',value:'4'},
          {text:'Teilschritt', value:'3'},
          {text:'YouTube Video',value:'6'}
        ],
        stepAttributeHeizart:[
          {text:'Vorheizen',value:'Cooking.Oven.Program.HeatingMode.PreHeating', selected:false},
          {text:'Heißluft',value:'Cooking.Oven.Program.HeatingMode.HotAir', selected:false},
          {text:'Heißluft Eco',value:'Cooking.Oven.Program.HeatingMode.HotAirEco', selected:false},
          {text:'Heißluft Grillen',value:'Cooking.Oven.Program.HeatingMode.HotAirGrilling', selected:false},
          {text:'Ober/Unterhitze',value:'Cooking.Oven.Program.HeatingMode.TopBottomHeating', selected:false},
          {text:'Ober/Unterhitze Eco',value:'Cooking.Oven.Program.HeatingMode.TopBottomHeatingEco', selected:false},
          {text:'Unterhitze',value:'Cooking.Oven.Program.HeatingMode.BottomHeating', selected:false},
          {text:'Pizzaeinstellung',value:'Cooking.Oven.Program.HeatingMode.PizzaSetting', selected:false},
          {text:'Langsam garen',value:'Cooking.Oven.Program.HeatingMode.SlowCook', selected:false},
          {text:'Intensive Hitze',value:'Cooking.Oven.Program.HeatingMode.IntensiveHeat', selected:false},
          {text:'Warmhalten',value:'Cooking.Oven.Program.HeatingMode.KeepWarm', selected:false},
          {text:'Ofengeschirr aufwärmen',value:'Cooking.Oven.Program.HeatingMode.PreheatOvenware', selected:false},
          {text:'Gefrorenes aufwärmen Spezial',value:'Cooking.Oven.Program.HeatingMode.FrozenHeatupSpecial', selected:false},
          {text:'Trocknen von Gemüse/Obst/Kräutern',value:'Cooking.Oven.Program.HeatingMode.Desiccation', selected:false},
          {text:'Auftauen',value:'Cooking.Oven.Program.HeatingMode.Defrost', selected:false},
          {text:'Brot und Hefe-Teige',value:'Cooking.Oven.Program.HeatingMode.Proof', selected:false},

        ],
        helpTexts: [
          {id:'Cooking.Oven.Program.HeatingMode.PreHeating',value:'Diese Heizart kann zum Vorheizen des Ofens verwendet werden. Es startet ein Heißluftprogramm mit der Option zum schnellen Vorheizen. Bitte beachten Sie, dass die Solltemperatur gleich oder höher als 100°C sein muss, da sonst die Option zum schnellen Vorheizen nicht aktiviert ist.\n'},
          {id:'Cooking.Oven.Program.HeatingMode.HotAir',value:'Diese Heizart eignet sich zum Backen auf einer oder mehreren Ebenen.'},
          {id:'Cooking.Oven.Program.HeatingMode.HotAirEco',value:'Diese Heizart eignet sich zum energieoptimierten Garen ausgewählter Gerichte auf einer Ebene ohne Vorheizen.'},
          {id:'Cooking.Oven.Program.HeatingMode.HotAirGrilling',value:'Diese Heizart eignet sich zum Braten von Geflügel, ganzem Fisch und größeren Fleischstücken.'},
          {id:'Cooking.Oven.Program.HeatingMode.TopBottomHeating',value:'Diese Heizart eignet sich zum traditionellen Backen und Braten auf einer Ebene.'},
          {id:'Cooking.Oven.Program.HeatingMode.TopBottomHeatingEco',value:'Diese Heizart eignet sich zum energieoptimierten Garen ausgewählter Gerichte auf einer Ebene ohne Vorheizen.'},
          {id:'Cooking.Oven.Program.HeatingMode.BottomHeating',value:'Diese Heizart eignet sich zum Kochen im Wasserbad und für die letzte Backstufe.'},
          {id:'Cooking.Oven.Program.HeatingMode.PizzaSetting',value:'Diese Heizart eignet sich zur Zubereitung von Pizza.'},
          {id:'Cooking.Oven.Program.HeatingMode.SlowCook',value:'Diese Heizart eignet sich zum schonenden und langsamen Garen.'},
          {id:'Cooking.Oven.Program.HeatingMode.IntensiveHeat',value:'Diese Heizart eignet sich für Gerichte mit knuspriger Basis. Die Wärme wird von oben und intensiver von unten abgegeben.'},
          {id:'Cooking.Oven.Program.HeatingMode.KeepWarm',value:'Der Heiztyp eignet sich zum Warmhalten von gekochtem Geschirr.'},
          {id:'Cooking.Oven.Program.HeatingMode.PreheatOvenware', value:'Dieser Heiztyp eignet sich zum Erwärmen von Geschirr.'},
          {id:'Cooking.Oven.Program.HeatingMode.FrozenHeatupSpecial', value:'Dieser Heiztyp eignet sich zur schnellen Zubereitung von Tiefkühlprodukten auf Stufe 1.'},
          {id:'Cooking.Oven.Program.HeatingMode.Desiccation', value:'Diese Heizart eignet sich zum Trocknen von Kräutern, Obst und Gemüse.'},
          {id:'Cooking.Oven.Program.HeatingMode.Defrost', value:'Diese Heizart eignet sich zum schonenden Auftauen von Tiefkühlkost.'},
          {id:'Cooking.Oven.Program.HeatingMode.Proof', value:'In Proof verwendet der Ofen die oberen und unteren Elemente, um eine niedrige Temperatur aufrechtzuerhalten und Brot oder andere Hefeteige zu prüfen.'},

        ],
        recipePartInformationToolbar:[["bold", "italic", "underline","link"], [{ list: "ordered" }, { list: "bullet" }]]
      }
    },
    methods:{
      addRowToParts: function() {
        this.postItem.content_container.push({
          record_id: '',
          content_type: 0,
          content_note_type: 0,
          content_element_title:'',
          content_element_text:'',
          position:0,
          step_attribute_heizart:'',
          step_attribute_zeit:'',
          step_attribute_temperatur:'',
        });
      },
      removeElementFromParts: function(index,whichArray) {
        if(whichArray === 'recipe'){
          this.postItem.content_container.splice(index, 1);
        }else if(whichArray === 'ingredient'){
          this.postItem.recipe_container.splice(index, 1);
        }
      },
      stripTags(str){
        return str.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '')
      },
      showHelpText(value){
        this.helpTexts.forEach(item => {
          if(item.id === value){
            this.helptext = item.value;
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>